/**
 * Set as ZodError.name to know which validation failed
 */
export enum ContentComponentValidationErrorName {
  translatedEntities = 'ContentComponentTranslatedEntitiesValidationError',
  configuration = 'ContentComponentConfigurationValidationError',
}
